// @flow

import React from 'react'

import clientData from 'utils/client-data'
import { get } from 'lodash'
import SlugRecipientProfile from './slug-recipient-profile'
import SlugSellerRecipientProfile from '../seller/slug-seller-recipient-profile.js'
import SlugNotFound from './slug-not-found'

const { recipientSlugDetails: { slugDetails = {} } = {} } = clientData
const isSellerProfile = get(slugDetails, 'intent') === 'COMMERCE'
function SlugDetails(props) {
  const RecipientProfile = isSellerProfile
    ? SlugSellerRecipientProfile
    : SlugRecipientProfile
  return (
    <>
      {clientData.slug && slugDetails.isProfileStatusActive ? (
        <RecipientProfile
          {...props}
          {...(isSellerProfile
            ? {
                previewData: slugDetails,
                locale: get(clientData, 'locality.locale'),
              }
            : { slugDetails: slugDetails })}
        />
      ) : (
        <SlugNotFound />
      )}
    </>
  )
}

export default SlugDetails
